/**
 * This is a list of error codes with their description that might be returned by the AVE.
 * For a detailed error description regarding a specific request, see the requests documentation.
 *
 * Error Codes:
 * - Unknown: Used for unknown errors mostly produces by Unreal Engine System, which cannot be clearly assign to a specific Error Code.
 *
 * - Missing_Resource: Used for errors where a requested resource was not found.
 *
 * - Missing_Resource_Animation: Used for errors where a requested animation was not found.
 *
 * - Missing_Resource_Camera: Used for errors where a requested camera was not found.
 *
 * - Missing_Resource_Car: Used for errors where a requested car was not found.
 *
 * - Missing_Resource_Environment: Used for errors where a requested environment was not found.
 *
 * - Failed_Access_Resource: Used for errors where a requested resource cannot be accessed.
 *
 * - Unsupported_EventL Used for errors with unknown/unsupported AVE events.
 *
 * - RuleEngine_Rule_Violation: Used for error-responses for external requests that violate rules.
 *
 * - NotInitialized: Used when a system is not initialized or still loading.
 *
 * - Invalid_Value: Used when a value is invalid.
 */
export var AveErrorCode;
(function (AveErrorCode) {
    AveErrorCode["Unknown"] = "Unknown";
    AveErrorCode["Missing_Resource"] = "Missing_Resource";
    AveErrorCode["Missing_Resource_Animation"] = "Missing_Resource_Animation";
    AveErrorCode["Missing_Resource_Camera"] = "Missing_Resource_Camera";
    AveErrorCode["Missing_Resource_Car"] = "Missing_Resource_Car";
    AveErrorCode["Missing_Resource_Environment"] = "Missing_Resource_Environment";
    AveErrorCode["Failed_Access_Resource"] = "Failed_Access_Resource";
    AveErrorCode["Unsupported_Event"] = "Unsupported_Event";
    AveErrorCode["RuleEngine_Rule_Violation"] = "RuleEngine_Rule_Violation";
    AveErrorCode["NotInitialized"] = "NotInitialized";
    AveErrorCode["Invalid_Value"] = "Invalid_Value";
})(AveErrorCode || (AveErrorCode = {}));
//# sourceMappingURL=error-codes.js.map